'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 288 271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("path", {
    id: "empty-statistics_svg__a",
    d: "M0 109h288V0H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "empty-statistics_svg__e",
    d: "M0 .025h9.204V20.28H0z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "empty-statistics_svg__g",
    d: "M.863.717h14.095V9.17H.863z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    id: "empty-statistics_svg__i",
    d: "M0 .632h51.336v28.133H0z"
  }), /*#__PURE__*/React__namespace.createElement("circle", {
    id: "empty-statistics_svg__c",
    cx: 144.5,
    cy: 135.5,
    r: 135.5
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    fill: "#B4CBEB",
    cx: 144.5,
    cy: 135.5,
    r: 135.5
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(0 35)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "m77 4 1.373.06c.322.013 32.567 1.4 64.571 1.4h.555c32.19-.015 64.803-1.387 65.128-1.4L210 4V102l-1.373-.059c-.325-.013-32.938-1.385-65.128-1.4h-.555c-32.002 0-64.249 1.387-64.57 1.4L77 102V4Z",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M143.5 9.44C111.75 9.458 80 8 80 8v98s31.75-1.457 63.5-1.44c31.75.016 63.5 1.44 63.5 1.44V8s-31.75 1.424-63.5 1.44",
    stroke: "#BFBEC8",
    fill: "#FFF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m124.09 29 2.91-2.675C123.066 21.829 117.355 19 111 19v4.009c5.199 0 9.87 2.312 13.09 5.991",
    fill: "#D6EAF9"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111 23v4.583c3.84 0 7.29 1.706 9.666 4.417L124 28.94c-3.198-3.647-7.837-5.94-13-5.94",
    fill: "#F1F4FF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m127.34 26-2.997 2.616c2.878 3.122 4.629 7.25 4.629 11.775 0 6.492-3.604 12.164-8.972 15.224L122.033 59C128.594 55.26 133 48.326 133 40.39c0-5.53-2.14-10.574-5.66-14.39",
    fill: "#0969AA"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M124.485 40.775A13.11 13.11 0 0 1 118 52.097L120.279 56c5.218-3.06 8.721-8.733 8.721-15.225 0-4.526-1.702-8.653-4.5-11.775l-3.362 3.02a13.068 13.068 0 0 1 3.347 8.755",
    fill: "#F1F4FF"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111 22.95V19c-10.627 0-19.435 7.978-21 18.396l3.82.604c1.281-8.523 8.485-15.05 17.18-15.05",
    fill: "#0969AA"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M111 27.63V23c-8.604 0-15.732 6.631-17 15.29l4.359.71c.942-6.44 6.242-11.37 12.641-11.37",
    fill: "#1098F3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M110.931 58.056c-9.909 0-17.942-7.94-17.942-17.737 0-.922.072-1.83.209-2.716L89.255 37A21.73 21.73 0 0 0 89 40.319C89 52.293 98.82 62 110.931 62c4.037 0 7.82-1.079 11.069-2.962l-2.013-3.405a18.004 18.004 0 0 1-9.056 2.423",
    fill: "#1098F3"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M110.944 53.554c-7.37 0-13.343-5.776-13.343-12.899 0-.67.053-1.33.155-1.974L93.21 38A16.998 16.998 0 0 0 93 40.655C93 50.235 101.034 58 110.944 58c3.302 0 6.398-.863 9.056-2.369l-2.322-3.84a13.624 13.624 0 0 1-6.734 1.763",
    fill: "#D6EAF9"
  }), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-statistics_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-statistics_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "M93 73h8v-2h-8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#202338",
    mask: "url(#empty-statistics_svg__b)",
    d: "M102 73h8v-2h-8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6EAF9",
    mask: "url(#empty-statistics_svg__b)",
    d: "M111 73h8v-2h-8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M120 73h8v-2h-8z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#D6EAF9",
    mask: "url(#empty-statistics_svg__b)",
    d: "m197 28-5.273 5.443-5.272 7.6-5.273-2.28-5.273 5.32-5.273 10.638-5.237-5.301-5.308 2.72-5.273 5.083-5.273-2.502-5.272 5.32L139 65.36V76h58z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M138.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M143.5 76c-.03 0-.058-.014-.058-.033V17.032c0-.018.028-.032.058-.032.03 0 .058.014.058.032v58.935c0 .019-.028.033-.058.033M149.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M154.5 76c-.031 0-.058-.014-.058-.033V17.032c0-.018.026-.032.058-.032.03 0 .058.014.058.032v58.935c0 .019-.028.033-.058.033M159.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M165.5 76c-.03 0-.058-.014-.058-.033V17.032c0-.018.028-.032.058-.032.03 0 .058.014.058.032v58.935c0 .019-.028.033-.058.033M170.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M175.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M181.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M186.5 76c-.031 0-.058-.014-.058-.033V17.032c0-.018.026-.032.058-.032.03 0 .058.014.058.032v58.935c0 .019-.028.033-.058.033M191.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033M196.5 76c-.031 0-.057-.014-.057-.033V17.032c0-.018.026-.032.057-.032.031 0 .057.014.057.032v58.935c0 .019-.026.033-.057.033",
    fill: "#7F7F7F",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M196.968 33.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 38.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 43.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 49.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 54.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 59.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.055 0 .032-.015.057-.032.057M196.968 65.556h-57.936c-.018 0-.032-.025-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.025.032.055 0 .032-.015.058-.032.058M196.968 70.556h-57.936c-.018 0-.032-.025-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.025.032.055 0 .032-.015.058-.032.058M196.968 75.556h-57.936c-.018 0-.032-.025-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.025.032.055 0 .032-.015.058-.032.058M196.968 17.556h-57.936c-.018 0-.032-.024-.032-.056s.014-.056.032-.056h57.936c.017 0 .032.024.032.056s-.015.056-.032.056M196.968 22.556h-57.936c-.018 0-.032-.024-.032-.056 0-.03.014-.056.032-.056h57.936c.017 0 .032.026.032.056 0 .032-.015.056-.032.056M196.968 27.556h-57.936c-.018 0-.032-.026-.032-.056 0-.032.014-.056.032-.056h57.936c.017 0 .032.024.032.056 0 .03-.015.056-.032.056",
    fill: "#7F7F7F",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "m139.184 65-.184-.183 10.576-10.55 5.259 2.467 5.204-4.96 5.357-2.751 5.196 5.182 5.185-10.343.014-.015 5.318-5.304 5.24 2.24 5.21-7.42L196.814 28l.185.181-5.249 5.357-5.31 7.567-5.272-2.254-5.18 5.165-5.326 10.627-5.316-5.303-5.155 2.647-5.307 5.057-5.254-2.464z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M139 66a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M139 64a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M144 61c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M144 59a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.001 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M149 55a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M149 53a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M155 58c-.551 0-1-.449-1-1a1.001 1.001 0 0 1 2 0c0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M155 56a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.001 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M160 53a1.001 1.001 0 0 1 0-2 1 1 0 0 1 0 2",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M160 51a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M165 50c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M165 48a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.001 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M170 55a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M170 53a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M176 45c-.551 0-1-.449-1-1a1.001 1.001 0 0 1 2 0c0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M176 43a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.001 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M181 39a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M181 37a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M186 42c-.551 0-1-.449-1-1a1.001 1.001 0 0 1 2 0c0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M186 40a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.001 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M192 34a1.001 1.001 0 0 1 0-2c.551 0 1 .449 1 1 0 .551-.449 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M192 32a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 1 1-.002 1.54.77.77 0 0 1 .002-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M197 29a1.001 1.001 0 1 1 1-1c0 .551-.448 1-1 1",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M197 27a1 1 0 1 0 0 2 1 1 0 0 0 0-2m0 .23a.77.77 0 0 1 0 1.54.77.77 0 0 1 0-1.54",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#F1F4FF",
    mask: "url(#empty-statistics_svg__b)",
    d: "M92 83h105v-2H92zM92 86h105v-1H92zM92 89h105v-1H92zM92 92h105v-1H92zM92 95h105v-1H92zM92 98h105v-1H92z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M35.5 1.964C22.751 1.57 0 0 0 0v105s22.751-1.572 35.5-1.964c12.748-.393 35.5-1.572 35.5-1.572V3.535S48.248 2.356 35.5 1.964",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.3,
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M38.5 6.964C25.753 6.572 3 5 3 5v105s22.752-1.572 35.5-1.964c12.749-.393 35.5-1.572 35.5-1.572V8.536s-22.751-1.18-35.5-1.572",
    stroke: "#BFBEC8",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M14 97.969h50v-.938H14zM13.365 97h.27V12h-.27zM19 97h3V39h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7CB8",
    mask: "url(#empty-statistics_svg__b)",
    d: "M22 97h3V80h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M27 97h3V76h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7CB8",
    mask: "url(#empty-statistics_svg__b)",
    d: "M30 97h3v-7h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M35 97h3V36h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7CB8",
    mask: "url(#empty-statistics_svg__b)",
    d: "M38 97h3V45h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M42 97h3V12h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7CB8",
    mask: "url(#empty-statistics_svg__b)",
    d: "M46 97h3V18h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M50 97h3V32h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#6F7CB8",
    mask: "url(#empty-statistics_svg__b)",
    d: "M53 97h3V65h-3z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M252.5 1.964C265.247 1.57 288 0 288 0v105s-22.752-1.572-35.5-1.964c-12.749-.392-35.5-1.571-35.5-1.571V3.535s22.751-1.179 35.5-1.571",
    fill: "#3F3E4B",
    fillRule: "nonzero",
    opacity: 0.3,
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M284.5 5.535v103.93c-2.154-.147-10.506-.708-19.316-1.201l-1.419-.079-.948-.051-.948-.051-.946-.05a575.027 575.027 0 0 0-11.023-.485 968.654 968.654 0 0 1-10.365-.384l-.94-.039-.943-.04-1.42-.061-1.422-.063-1.417-.063a3168.59 3168.59 0 0 1-18.893-.909V9.011c2.017-.104 10.18-.519 18.893-.91l.944-.041 1.894-.084 1.42-.06.944-.041.94-.04c3.434-.142 6.748-.27 9.594-.359 3.449-.106 7.088-.269 10.851-.46l.943-.05.946-.05c1.263-.066 2.531-.136 3.789-.207l.94-.053a1760.38 1760.38 0 0 0 17.902-1.12Z",
    stroke: "#BFBEC8",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M250.132 36 240 19.988A18.688 18.688 0 0 1 250.132 17c4.778 0 9.382 1.837 12.868 5.135L250.132 36Z",
    fill: "#0B87DB",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m250.62 36 18.38.842C268.566 46.938 260.406 55 250.62 55c-5.73 0-11.142-2.764-14.62-7.466L250.62 36Z",
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M233.37 48.084c-2.818-3.638-4.37-8.158-4.37-12.729 0-3.522.914-7.02 2.644-10.114a21.262 21.262 0 0 1 7.27-7.622l.99-.619L252 35.63 234.08 49l-.71-.916Z",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M250 35.884 234.079 48c-.1-.131-.198-.264-.293-.398-.012-.016-.026-.033-.037-.05a8.56 8.56 0 0 1-.24-.344 8.425 8.425 0 0 1-.231-.345 7.453 7.453 0 0 1-.222-.346c-.062-.097-.122-.195-.182-.293l-.03-.054a6.128 6.128 0 0 1-.151-.257c-.059-.098-.114-.196-.168-.294a16.655 16.655 0 0 1-.401-.76c-.053-.103-.102-.206-.152-.308l-.026-.054A20.038 20.038 0 0 1 230 35.884 20.043 20.043 0 0 1 239.253 19L250 35.884Z",
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M247 37.034 261.98 21l.887.828a19.37 19.37 0 0 1 6.114 14.96L268.928 38 247 37.034Z",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M250 35.262 261.603 23a16.68 16.68 0 0 1 5.38 13L250 35.262Z",
    fill: "#D6EAF9",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M244 35.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0",
    fill: "#FFF",
    mask: "url(#empty-statistics_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M221 66h18v-3h-18z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0B87DB",
    mask: "url(#empty-statistics_svg__b)",
    d: "M239 66h18v-3h-18zM236 73h17v-3h-17z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "M257 66h20v-3h-20zM253 73h24v-3h-24z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0B87DB",
    mask: "url(#empty-statistics_svg__b)",
    d: "M230 79h35v-3h-35z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "M265 79h12v-3h-12z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0B87DB",
    mask: "url(#empty-statistics_svg__b)",
    d: "M240 86h5v-3h-5z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "M245 86h32v-3h-32z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0B87DB",
    mask: "url(#empty-statistics_svg__b)",
    d: "M252 92h5v-3h-5zM259 99h9v-3h-9z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#0969AA",
    mask: "url(#empty-statistics_svg__b)",
    d: "M258 92h19v-3h-19zM268 99h9v-3h-9z"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    fill: "#1098F3",
    mask: "url(#empty-statistics_svg__b)",
    d: "M221 73h15v-3h-15zM221 79h9v-3h-9zM221 86h19v-3h-19zM221 92h31v-3h-31zM221 99h38v-3h-38z"
  })), /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-statistics_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-statistics_svg__c"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#empty-statistics_svg__d)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M258.682 269.999c-1.671.132-2.1-8.794-2.173-8.995-.698 2.22-1.647 4.28-2.26 2.913-.707-1.574.29-9.394.572-11.426.294-2.117 4.346-1.595 4.757-.777.85 1.693 3.895 7.862 3.36 11.804-.137 1.008-1.292 6.247-4.256 6.48",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(168 98)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-statistics_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-statistics_svg__e"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M2.377.037C4.12-.381 6.154 10.71 6.371 9.634c.435-2.16.63-4.086 1.644-3.299.458.355.85 2.326 1.012 3.816.334 3.06.092 6.652.096 8.097.006 2.238-4.34 2.381-4.896 1.604C3.077 18.245 0 15.56 0 11.392c0-1.509 2.502-.822 3.172-2.625.52-1.396-2.144-8.407-.795-8.73",
    fill: "#E2AD9D",
    mask: "url(#empty-statistics_svg__f)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M225 178.017s-4.008-7.096-3.841-14.193c.167-7.097-9.689-2.365-10.19-1.183-.5 1.183-1.91 10.476-4.903 17.44-1.333 3.1 17.932 5.37 18.934-2.064",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M236.186 241.709s2.514 58.852 2.244 65.362c-.27 6.511 1.635 63.122 1.568 65.88-.065 2.758-8.07 2.713-8.354-.023-.46-4.435-7.384-50.59-9.234-63.017-1.537-10.32-11.726-61.98-12.394-65.24-.668-3.262 19.786-9.142 26.17-2.962",
    fill: "#202338"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M200.725 241.504s-10.678 36.64-12.223 74.131c-1.064 25.794-.202 55.262.436 57.997.638 2.735 8.193 3.554 8.6 0 .41-3.553 1.485-33.13 6.511-58.26 3.364-16.82 10.58-26.072 15.403-41.109 4.975-15.516 5.122-27.647 5.523-29.297.791-3.246-17.574-9.444-24.25-3.462",
    fill: "#252A43"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M205 149.636c0 9.038 5.15 16.364 11.5 16.364 6.352 0 11.5-7.326 11.5-16.364S222.852 136 216.5 136c-6.35 0-11.5 4.598-11.5 13.636",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M260.988 251.765c-.52-3.576-1.095-26.038-6.766-41.677-2.844-7.836-11.448-31.724-18.856-36.238-.015-.008-.03-.023-.045-.03l-.026-.012a5.388 5.388 0 0 0-1.164-.528c-7.28-3.099-19.662-4.414-28.219-1.516-4.81-.6-12.716-6.555-18.193-20.661-3.325-8.567-7.644-30.518-8.273-34.123-.636-3.643-8.853-1.644-8.43 1.071.598 3.835 1.631 27.878 7.656 44.725 3.206 8.968 14.01 23.243 19.213 35.815.881 16.921 2.934 38.642-.133 50.417-2.334 8.953 39.54 7.026 39.101-.21-.585-9.662.388-27.918.817-44.01 2.051 3.756 4.036 8.058 7.332 16.386 3.146 7.947 7.023 28.392 7.582 31.75.564 3.395 8.773 1.372 8.404-1.16",
    fill: "#0969AA"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M209.963 134.452c2.301-2.087 13.704-2.37 15.743 2.163 9.408 5.38 1.139 26.38-3.796 26.385-3.222.003-5.285-10.37-10.619-10.516-2.615-.07-2.106-7.52-4.694-7.91-2.244-.34-3.623-2.61-3.597-4.867.032-2.747 1.774-6.08 6.963-5.255",
    fill: "#202338"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M212 152.5c0 1.932.671 3.5 1.5 3.5.827 0 1.5-1.568 1.5-3.5 0-1.933-.673-3.5-1.5-3.5-.829 0-1.5 1.567-1.5 3.5M210 166s5.927-2.912 4.875-2.742c-1.065.172-1.865.145-3.94-.258-.242.765-.935 3-.935 3",
    fill: "#E2AD9D"
  })), /*#__PURE__*/React__namespace.createElement("g", {
    mask: "url(#empty-statistics_svg__d)"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M97.35 342.35c.027 2.332-4.025 1.507-4.228-.4-.013-.129-3.842-27.537-6.669-56.315-1.052-10.702-5.087-35.473-5.949-45.204-1.565-17.67 1.325-17.697 1.843-19.75 4.167-16.484 14.646-6.472 16.272.533 2.441 10.52-1.276 120.803-1.269 121.135",
    fill: "#202338"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M67.807 341.598c.32-1.683 18.513-112.965 17.264-120.3-2.856-16.762-12.559-15.074-15.67-8.593-1.333 2.778-5.374 12.491-5.876 26.601-.444 12.506 2.213 29.298 1.428 45.02-1.498 30.012-1.478 52.522-1.393 57.334.04 2.273 3.927 1.622 4.247-.062",
    fill: "#252A43"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M63.92 220.188c.04-1.539-10.97-15.48-10.973-25.613-.004-14.185 11.874-34.55 13.368-36.713 3.69-5.343 7.193 8.235 4.436 14.142-2.571 5.51-7.967 13.09-8.597 22.46-.688 10.245 4.598 22.298 5.548 24.401.452 1.001-3.81 2.465-3.781 1.323",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(139 159.368)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-statistics_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-statistics_svg__g"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M14.729 1.499c-.602-1.227-6.648 1.91-6.81 1.935C9.09 2.087 10.054.626 8.902.72 7.576.83 2.7 4.79 1.296 5.568c-1.426.79 1.07 3.628 1.778 3.602 1.464-.053 6.775-.286 9.147-2.182.606-.484 3.575-3.313 2.508-5.49",
    fill: "#E2AD9D",
    mask: "url(#empty-statistics_svg__h)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M142.225 168.563c-2.814 1.898-17.28 14.752-27.848 16.56-6.194 1.058-12.536-8.442-19.745-18.357-3.23-4.446 2.925-8.626 7.485-5.52 4.253 2.896 9.551 14.122 12.091 14.562 8.878 1.54 21.578-9.022 26.741-11.14.86-.353 2.323 3.188 1.276 3.895",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M112.08 174.045c-1.127 2.247-4.958 5.695-7.139 6.074-.523.088-.947.004-1.22-.319-1.733-2.044-2.438-2.742-3.997-4.849-1.12-1.517.97 4.32-1.746 12.044-3.455 9.817.253 27.21 1.728 35.798.056.323-.218.67-.74 1.018-2.129 1.404-8.418 2.795-14.043 2.363a24.842 24.842 0 0 1-1.27-.129 32.934 32.934 0 0 1-3.172-.573c-7.135-1.639-12.862-5.327-13.114-7.682a1.266 1.266 0 0 1 .144-.777c.178-.326.34-.649.481-.966.003-.01.01-.02.01-.028.155-.34.285-.674.397-1.01.65-1.939.727-3.905.801-6.763.056-2.234.108-5.01.428-8.747.593-6.869.101-20.756-.664-21.107-.628-.292-1.836 2.61-2.613 4.07-.164.31-.308.554-.424.691-.28.334-.657.544-1.096.657-2.573.667-7.377-2.132-8.697-4.744-.274-.55-.397-1.092-.313-1.594.618-3.62 7.033-16.398 9.751-19.176a8.618 8.618 0 0 1 1.28-1.084c.297-.208.595-.387.894-.534a6.43 6.43 0 0 1 1.752-.6c1.686-.66 4.066-1.117 6.756-1.374 4.213-.407 9.19-.326 13.451.215.078-.004.148-.015.23-.01h.006c2.893.147 8.08 1.053 10.618 3.22 5.081 4.335 10.095 11.804 11.725 14.381.217.348.12.892-.204 1.535",
    fill: "#0B87DB"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M67.701 218.865c.45.94 1.562 2.467 1.779 4.426.184 1.663-.527 4.057-.573 4.971-.063 1.237-1.293 1.61-1.16.301.197-1.914-.165-2.886-.58-2.832-.416.054-1.924 4.25-2.333 7.722-.112.956-.743 1.696-1.346 1.133-.802-.75-.465-6.619-.341-7.832.123-1.213.834-6.135.77-6.698-.052-.458 1.755-1.139 1.852-1.642l1.932.451ZM96.25 129.879c-1.09-7.976-9.652-10.477-15.184-9.25-5.532 1.226-7.765 7.357-6.125 15.238.974 4.677 4.99 8.746 5.03 11.516.033 2.415-.376 5.878-.554 6.344-.178.464-2.475.923-3.082.97-.126.01.346 2.595 3.563 4.737 1.892 1.259 5.08 2.05 7.17 1.15 3.342-1.438 3.257-4.81 3.232-5.654-.246-.113-2.31-.893-2.248-1.751.08-1.098-.155-3.462.814-3.612 1.65-.254 2.738-.085 4.167-.437 2.382-.586 4.647-8.776 3.216-19.251",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("g", {
    transform: "translate(46 118.368)"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "empty-statistics_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#empty-statistics_svg__i"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M51.116 10.84c.975-4.99-1.205-8.834-8.215-9.128-5.206-2.574-9.522-.149-12.275 3.096-.005-.01-.01-.02-.014-.032-.534-1.14-1.585-1.977-2.77-2.216-2.03-.41-4.283.62-6.018 2.172-1.735 1.553-3.052 3.58-4.345 5.571-1.292 1.991-2.618 4.014-4.366 5.55-3.427 3.011-8.31 3.556-11.745 1.513 1.414 1.7 2.906 3.324 4.725 4.495.589.38 1.22.705 1.879.964-2.59.797-5.448.762-7.972-.198 2.034 1.585 4.142 3.082 6.514 4.07 2.972 1.235 6.466 1.59 9.372.204 3.784-1.805 5.697-5.983 7.506-9.765 1.063-2.223 2.32-4.6 4.112-6.383-1.288 6.792 6.216 19.886 6.907 17.786.725-2.199 2.46-11.105 4.743-11.582 4.225-.885 4.268-7.655 4.268-7.655s1.9-2.478 4.272-.942c3.595 2.328 2.252 8.47 3.422 2.48",
    fill: "#000",
    mask: "url(#empty-statistics_svg__j)"
  })), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.431 140.999c-1.098 0-1.989-1.496-1.989-3.341 0-1.846.89-3.342 1.99-3.342 1.097 0 1.989 1.496 1.989 3.342 0 1.845-.892 3.34-1.99 3.34",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "m73.863 129.091-.443-.288 1.412-2.651c.061-.157.12-.311.178-.466.413-1.085.802-2.109 1.575-2.79l1.097-.969-2.367 4.447c-.346.885-.765 1.838-1.452 2.718",
    fill: "#D46372"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M83.431 148.232c-.938-.018 4.652 3.597 4.653 3.587 0-.01-.07-1.884.561-2.168 0 0-4.408-1.404-5.213-1.42",
    fill: "#E2AD9D"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M70.06 202.515c-.202 2.264-.629 4.428-.86 5.73.056-2.233.108-5.01.428-8.747.593-6.868.101-20.755-.664-21.107-.628-.29-1.836 2.61-2.612 4.07a53.88 53.88 0 0 1-.02-.253s.845-4.48 2.397-4.603c1.556-.119 1.796 9.476 1.764 10.013-.028.537-.19 12.178-.433 14.897",
    fill: "#A8BBF1"
  }))));
});
var EmptyStatistics = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.EmptyStatistics = EmptyStatistics;